import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Optional,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ForumThreadRead } from "src/app/shared/interfaces/forum";
import { SharedModule } from "src/app/shared/shared.module";

export type ForumThreadReadUsersModalData = {
  reads: ForumThreadRead[];
};

@Component({
  selector: "forum-thread-read-users-modal",
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: "./forum-thread-read-users-modal.component.html",
  styleUrls: ["./forum-thread-read-users-modal.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForumThreadReadUsersModalComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<ForumThreadReadUsersModalComponent>,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public readonly data: ForumThreadReadUsersModalData,
  ) {}

  get reads(): ForumThreadRead[] {
    return this.data?.reads || [];
  }

  getUserNameParts(name: string): { firstName: string; lastName: string } {
    const [firstName = "", ...rest] = (name || "").trim().split(/\s+/);

    return {
      firstName,
      lastName: rest.join(" "),
    };
  }

  trackByRead(_index: number, read: ForumThreadRead): string {
    return `${read.user.id}-${read.read_at}`;
  }

  close(): void {
    this.dialogRef.close();
  }
}
